import CardValueSelectorController from 'components/card-value-selector/card-value-selector.controller';
import Form from 'components/form/form.component';
import MandatoryFieldsInstruction from 'components/form/mandatory-fields-instruction/mandatory-fields-instruction.component';
import PaymentSelectorWrapper from 'components/payment/payment-selector/payment-selector-wrapper/payment-selector-wrapper.component';
import GiftcardAddValueButtons from '../giftcard-add-value-buttons/giftcard-add-value-buttons.component';
import { useFormContext } from 'react-hook-form';
import { useContext } from 'react';
import SpreedlyCVVDialogContext from 'components/payment/spreedly/spreedly-card/spreedly-cvv-dialog/spreedly-cvv-dialog.context';
import { useDispatch } from 'react-redux';
import { addGiftCardValue, buyGiftCard } from 'redux/user/user.actions';
import { useCheckoutPaymentLoading } from 'pages/checkout/checkout.component';
import { useVerifyGiftCardPayingCard } from './gift-card-add-value-form.hooks';

const GiftCardAddValueForm = ({
  disabled,
  setCardId,
  submitLabel,
  paymentInstrumentId,
  cardId,
  handleClose,
  cards,
}) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
    trigger,
  } = useFormContext();
  const { handleCheckWithCVVRecacheDialogAndDoPayment } = useContext(
    SpreedlyCVVDialogContext,
  );
  const dispatch = useDispatch();
  const setPaymentLoading = useCheckoutPaymentLoading(
    state => state.setLoading,
  );
  const paymentLoading = useCheckoutPaymentLoading(state => state.loading);

  const verifyPayingCard = useVerifyGiftCardPayingCard(cardId);

  const onSubmit = async ({ amount }) => {
    setPaymentLoading(true);

    const amountInMilliunits = amount * 1000;
    const { token, ok } = await verifyPayingCard(amountInMilliunits);

    if (!ok) {
      setPaymentLoading(false);
      return;
    }

    const res = await dispatch(
      paymentInstrumentId
        ? addGiftCardValue(
            amountInMilliunits,
            cardId,
            paymentInstrumentId,
            token,
          )
        : buyGiftCard(amountInMilliunits, cardId, token),
    );

    if (res) handleClose();
    setPaymentLoading(false);
  };

  const handlePaymentSelection = newCardId => {
    setCardId(newCardId);
  };

  const submit = async data => {
    await handleCheckWithCVVRecacheDialogAndDoPayment(() => onSubmit(data));
  };

  const validate = async () => {
    await trigger();
  };

  return (
    <Form onSubmit={handleSubmit(submit)}>
      <MandatoryFieldsInstruction />
      <CardValueSelectorController control={control} errors={errors} />
      <PaymentSelectorWrapper
        handleSelection={handlePaymentSelection}
        selection={cardId}
        cards={cards}
      />
      <GiftcardAddValueButtons
        handleClose={handleClose}
        submitDisabled={disabled || paymentLoading}
        submitLabel={submitLabel}
        validate={validate}
        selection={cardId}
        cardIdentifier={paymentInstrumentId}
      />
    </Form>
  );
};

export default GiftCardAddValueForm;
